(() => {
 const popup = document.getElementById('vanity-community-popup');
 if (!popup) return;
 const key = 'vanity-community-popup-shown-v1';
 const week = 7 * 24 * 60 * 60 * 1000;
 let timer;
 let shown = false;
 const privacy = () => window.Shopify?.customerPrivacy;
 const accepted = () => {
  const consent = privacy()?.currentVisitorConsent?.();
  return consent && ['analytics','marketing','preferences'].some(type => consent[type] === 'yes');
 };
 const recentlyShown = () => {
  try { return Date.now() - Number(localStorage.getItem(key) || 0) < week; }
  catch { return shown; }
 };
 const close = () => { popup.hidden = true; };
 const overlaySelector = 'dialog[open], theme-drawer[open], header-drawer details[open], [popover]:popover-open, #header-component [aria-expanded="true"], [aria-modal="true"]:not([hidden])';
 const overlayOpen = () => [...document.querySelectorAll(overlaySelector)].some(element =>
  element !== popup && !popup.contains(element) && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden'
 );
 const syncOverlays = () => { if (!popup.hidden && overlayOpen()) close(); };
 const observer = new MutationObserver(syncOverlays);
 document.querySelectorAll('dialog, theme-drawer, header-drawer details, #header-component').forEach(element => {
  observer.observe(element, { attributes: true, subtree: element.id === 'header-component', attributeFilter: ['open', 'class', 'aria-expanded'] });
 });
 document.addEventListener('toggle', syncOverlays, true);
 document.addEventListener('click', () => requestAnimationFrame(syncOverlays), true);
 window.addEventListener('pagehide', () => { clearTimeout(timer); close(); });
 window.addEventListener('pageshow', syncOverlays);
 const open = () => {
  timer = null;
  if (!accepted() || recentlyShown() || document.visibilityState !== 'visible') return;
  if (overlayOpen()) {
   timer = setTimeout(open, 5000);
   return;
  }
  popup.hidden = false;
  shown = true;
  try { localStorage.setItem(key, String(Date.now())); } catch {}
 };
 const schedule = () => {
  if (!accepted()) { clearTimeout(timer); timer = null; close(); return; }
  if (!recentlyShown() && !timer) timer = setTimeout(open, 10000);
 };
 popup.querySelector('.vanity-community-popup__close').addEventListener('click', close);
 popup.querySelectorAll('.vanity-community-popup__secondary').forEach(link => link.addEventListener('click', close));
 document.addEventListener('keydown', event => { if(event.key === 'Escape') close(); });
 document.addEventListener('visitorConsentCollected', schedule);
 document.addEventListener('visibilitychange', () => { if(document.visibilityState === 'visible') schedule(); });
 if (popup.querySelector('[data-popup-success]') && accepted() && !overlayOpen()) popup.hidden = false;
 else if (privacy()) schedule();
 else if (window.Shopify?.loadFeatures) {
  window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {if(!error) schedule();});
 }
})();